export const GET_REPORTS = "admin/GET_REPORTS";
export const GET_REPORTS_SUCCESS = "admin/GET_REPORTS_SUCCESS";
export const GET_REPORTS_FAILURE = "admin/GET_REPORTS_FAILURE";
